const profileToggleSelector = '.profile-toggle';
let profileSettings = {};


function loadProfileSettings(){
    document.querySelectorAll(profileToggleSelector).forEach( item => {
        const attr = item.getAttribute('data-attribute');
        const storageKey = `cv-profile-${attr}`;
        let storageValue = window.sessionStorage.getItem(storageKey);
        if (!storageValue){
            profileSettings[storageKey] = 'false';
        } else {
            profileSettings[storageKey] = storageValue;
            if (storageValue === 'true'){
                item.checked = true;
                document.body.setAttribute(attr, '');
            }
        }
    });
}


function toggleProfileHandler(e){
    const profileToggle = e.target.closest(profileToggleSelector);
    if (profileToggle){
        const attr = profileToggle.getAttribute('data-attribute');
        document.body.toggleAttribute(attr);
        const storageKey = `cv-profile-${attr}`;
        const storageValue = window.sessionStorage.getItem(storageKey);
        if (!storageValue){
            window.sessionStorage.setItem(storageKey, 'true');
        } else {
            if (storageValue === 'true'){
                window.sessionStorage.setItem(storageKey, 'false');
            } else {
                window.sessionStorage.setItem(storageKey, 'true');
            }
        }
    }
}

export default {toggleProfileHandler, loadProfileSettings};